import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  uniqueAddressessCount: undefined,
  currentUniqueAddressesCount: undefined
}

const uniqueAddressesCountSlice = createSlice({
  name: 'uniqueAddressesCount',
  initialState,
  reducers: {
    setUniqueAddressessCount: (state, action) => {
      state.uniqueAddressessCount = action.payload
    },
    setCurrentUniqueAddressesCount: (state, action) => {
      state.currentUniqueAddressesCount = action.payload
    },
    clearUniqueAddressesCount: (state) => {
      state.uniqueAddressessCount = undefined
      state.currentUniqueAddressesCount = undefined
    }
  }
})

export const {setUniqueAddressessCount, clearUniqueAddressesCount, setCurrentUniqueAddressesCount} =
  uniqueAddressesCountSlice.actions

export const selectUniqueAddressessCount = (state) => state.uniqueAddressesCount.uniqueAddressessCount
export const selectCurrentUniqueAddressesCount = (state) => state.uniqueAddressesCount.currentUniqueAddressesCount

export default uniqueAddressesCountSlice.reducer
